import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/events";

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-shell mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="Categories"
          title="按主题找爆料"
          desc="六个长期跟踪的方向，每条爆料都归入对应专题，方便你只关注自己在意的那一类。"
        />
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/events?cat=${cat.slug}`}
              className="group flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200 hover:border-secondary-300 transition-colors cursor-pointer"
            >
              <span className="w-11 h-11 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center text-lg shrink-0 group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors">
                <i className={cat.icon} />
              </span>
              <span className="flex flex-col gap-1">
                <span className="flex items-center gap-2">
                  <span className="font-heading text-base font-bold text-foreground-950 group-hover:text-secondary-700 transition-colors">
                    {cat.name}
                  </span>
                  <span className="text-[11px] text-foreground-400">{cat.count} 条</span>
                </span>
                <span className="text-sm leading-relaxed text-foreground-600">{cat.desc}</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}